import { IMPLICIT_COLLECTION_PLACEHOLDER } from "../buildRequestTemplate";

import styles from "./ImplicitCollectionChip.module.css";

/**
 * Read-only display of the ``{{collection.id}}`` placeholder used by the
 * create-events goal. Not editable: a templated agent always files events
 * into the collection chosen at launch time, so hardcoding a collection_id
 * in the agent would be a trap.
 */
export function ImplicitCollectionChip() {
  return (
    <div className={styles.row}>
      <span className={styles.label}>Collection</span>
      <span className={styles.chip}>{IMPLICIT_COLLECTION_PLACEHOLDER}</span>
      <span className={styles.help}>
        Bound to the collection chosen at launch time.
      </span>
    </div>
  );
}
